module.exports = __webpack_public_path__ + "static/logo-light-91f6fcbd626a670a36059d57ba28839f.png";